export default function DnsTable({
  validCname,
  blogId,
  validCnameWww,
  showStatus,
}) {
  return (
    <table className="tw-w-full tw-table-auto tw-border-collapse tw-p-2 tw-border-2 tw-border-primary-100 dark:tw-border-primary-900 tw-border-solid">
      <thead className="tw-bg-primary-100 dark:tw-bg-primary-900">
        <tr cl>
          {showStatus && <th>Status</th>}
          <th>Type</th>
          <th>Name</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          {showStatus && (
            <td className="tw-border-2 tw-border-primary-100 dark:tw-border-primary-900 tw-border-solid tw-px-2">
              <span
                class={
                  'tw-inline-block tw-w-2 tw-h-2 tw-rounded-full ' +
                  (validCname ? 'tw-bg-green-500' : 'tw-bg-yellow-500')
                }
              ></span>
            </td>
          )}
          <td className="tw-border-2 tw-border-primary-100 dark:tw-border-primary-900 tw-border-solid tw-px-2">
            ALIAS or CNAME
          </td>
          <td className="tw-border-2 tw-border-primary-100 dark:tw-border-primary-900 tw-border-solid tw-px-2">
            @
          </td>
          <td className="tw-border-2 tw-border-primary-100 dark:tw-border-primary-900 tw-border-solid tw-px-2">
            {blogId}.truvvl.blog
          </td>
        </tr>
        <tr>
          {showStatus && (
            <td className="tw-border-2 tw-border-primary-100 dark:tw-border-primary-900 tw-border-solid tw-px-2">
              <span
                class={
                  'tw-inline-block tw-w-2 tw-h-2 tw-rounded-full ' +
                  (validCnameWww ? 'tw-bg-green-500' : 'tw-bg-yellow-500')
                }
              ></span>
            </td>
          )}
          <td className="tw-border-2 tw-border-primary-100 dark:tw-border-primary-900 tw-border-solid tw-px-2">
            CNAME
          </td>
          <td className="tw-border-2 tw-border-primary-100 dark:tw-border-primary-900 tw-border-solid tw-px-2">
            www
          </td>
          <td className="tw-border-2 tw-border-primary-100 dark:tw-border-primary-900 tw-border-solid tw-px-2">
            {blogId}.truvvl.blog
          </td>
        </tr>
      </tbody>
    </table>
  );
}
